<script lang="ts">
    import { onDestroy, onMount } from 'svelte'
    import { fade } from 'svelte/transition'

    import { gettext as _ } from 'hydria/services/gettext'
    interface Props {
        children?: import('svelte').Snippet
        close?: () => void
        mounted?: () => void
    }

    let { children, close = () => {}, mounted = () => {} }: Props = $props()

    const docHadModalClass = document.documentElement.classList.contains('modal-open')

    onMount(() => {
        if (!docHadModalClass) document.documentElement.classList.add('modal-open')
        mounted()
    })
    onDestroy(() => {
        if (!docHadModalClass) document.documentElement.classList.remove('modal-open')
    })
</script>

<style>
    .pe-base {
        position: relative;
    }
    .pe-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: #000;
        opacity: 0.5;
        z-index: 1050;
    }
    .pe-block {
        position: absolute;
        /* left: -9999px; */
        left: 0;
        top: 0;
        right: 0;

        z-index: 1055;

        width: auto;
        max-width: none;
        min-width: 18rem;
    }
</style>

<div class="pe-base">
    <div class="pe-block" transition:fade={{ duration: 250 }}>
        <div class="arrow"></div>
        <div class="popover-inner">
            {#if children}{@render children()}{:else}
                <div class="card">
                    <div class="card-header text-bg-primary"></div>
                    <div class="card-body"></div>
                    <div class="card-footer">
                        <button type="button" class="btn btn-sm btn-outline-secondary" onclick={() => close()}>{$_('Fermer')}</button>
                    </div>
                </div>
            {/if}
        </div>
    </div>
    <div
        class="pe-backdrop"
        onclick={() => {
            close()
        }}
        aria-hidden="true"
    ></div>
</div>
